<template>
	<div :class="['flex flex-col', small ? 'max-h-[85px]' : 'h-[100px]']" :style="{ width: width }">
		<div
			:class="[
				'bg-white flex flex-col border rounded-normal border-dj-gray-light cursor-text hover:border-dj-gray focus-within:border-dj-blue focus-within:hover:border-dj-blue',
				small ? 'py-2 px-5' : 'px-dj-30 py-4',
				{
					'border-dj-red hover:border-dj-red focus-within:border-dj-red focus-within:hover:border-dj-red':
						error.length && !disabled,
				}, // error
				{
					'bg-dj-gray-transparency hover:border-dj-gray-light cursor-not-allowed': disabled,
				}, // disabled
			]"
			@click="onClickFocus"
		>
			<span
				class="font-medium text-sm mb-1"
				:class="[{ 'text-dj-gray': disabled }, { 'text-xs font-normal': small }]"
			>
				{{ label }}
			</span>
			<input
				ref="inputRef"
				v-model="inputValue"
				:placeholder="placeholder"
				:disabled="disabled"
				:type="type"
				class="outline-none flex-1"
				:class="[{ 'disabled:bg-transparent cursor-not-allowed': disabled }, { 'text-sm': small }]"
			/>
		</div>
		<span v-if="error.length && !disabled" class="ml-dj-30 mt-1 font-medium text-xs text-dj-red">{{ error }}</span>
	</div>
</template>

<script lang="ts">
import { computed, ref, defineComponent } from "vue";
export default defineComponent({
	name: "BaseTextbox",
	props: {
		modelValue: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: "Input",
		},
		type: {
			type: String,
			default: "text",
			validator: (value: string) => {
				return ["text", "password", "email"].includes(value);
			},
		},
		error: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Type text",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		pattern: {
			type: String,
			default: "",
		},
		width: {
			type: String,
			default: "400px",
		},
		small: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const inputValue = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			},
		});

		const inputRef = ref<HTMLInputElement | null>(null);

		function onClickFocus() {
			inputRef.value?.focus();
		}

		return {
			inputValue,
			inputRef,
			onClickFocus,
		};
	},
});
</script>
